<script>
  import { Link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  onMount(() => {
    window.scrollTo(0, 0);
    const loggedin_user = localStorage.getItem("us");

    if (loggedin_user != null && !loggedin_user.isEmpty()) {
      navigate("/");
    }
  });

  let fetch_status = "";
  let fetch_status_data = "";
  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "fp.php";

  function preventDefault() {
    fetchdata();
  }

  async function fetchdata() {
    const phone = document.querySelector("#phonenumber").value;

    const response = await fetch(api_url, {
      method: "POST",
      body: JSON.stringify({ uphone: phone }),
    });

    const data = await response.json();

    const status = data.status;
    const status_data = data.content;

    fetch_status = status;
    fetch_status_data = status_data;

    if (status === "pass") {
      //console.log(status_data);
      localStorage.setItem("uotp", phone);
      navigate("/changepass");
    }
  }
</script>

<svelte:head>
  <title>Forget Password</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list justify-content-center">
            <li class="list-item">
              <h5 class="title text-center">
                <a href="/">
                  <img
                    src="./logo.png"
                    alt="veeranfashions"
                    width="100px"
                    height="100px"
                  /></a
                >
                <br />Veeran Fashions
              </h5>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Login Section:::... -->
  <div class="login-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="login-wrapper">
        <div class="section-content">
          <h1 class="title">Change Forgetten Password</h1>
        </div>
        {#if fetch_status === "fail"}
          <div class="pt-3">
            <div class="alert alert-danger" role="alert">
              {fetch_status_data}
            </div>
          </div>
        {/if}
        {#if fetch_status === "pass"}
          <div class="pt-3">
            <div class="alert alert-success" role="alert">
              {fetch_status_data}
            </div>
          </div>
        {/if}
        <form
          on:submit|preventDefault={preventDefault}
          class="default-form-wrapper"
        >
          <ul class="default-form-list">
            <li class="single-form-item">
              <label for="phonenumber" class="visually-hidden"
                >phonenumber</label
              >
              <input
                type="tel"
                id="phonenumber"
                maxlength="10"
                placeholder="Phone Number"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-telephone-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                  />
                </svg></span
              >
            </li>
          </ul>
          <br />
          <button class="button-login" type="submit" id="submit">Get OTP</button
          >
        </form>
      </div>

      <div class="create-account-text text-center">
        Have an account?
        <Link to="/login" class="btn--color-radical-red">Login now</Link>
      </div>
      <div class="create-account-text text-center">
        Don't have an account?
        <Link to="/register" class="btn--color-radical-red">Create now</Link>
      </div>
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->
</main>
